export default function () {
  $('.input').on('focusin focusout', function (e) {
    const $inputBlock = $(this).closest('.input-block');
    const $label = $inputBlock.find('.label');

    $label.toggleClass('label_scaled', !!$(this).val() || e.type === 'focusin');
    $inputBlock.toggleClass('input-block_focused', !!$(this).val() || e.type === 'focusin');
  });
}



// WEBPACK FOOTER //
// ./scripts/elements/form-input.js